<template>
	<v-container
		grid-list-xl
		pb-0
	>
		<v-progress-linear
			v-if="editOutput.saving"
			class="ma-0"
			indeterminate
		/>
		<v-form
			ref="form"
			v-model="valid"
			@submit.prevent="validateOutput"
		>
			<v-layout
				row
				wrap
				ma-0
				justify-center
				align-center
			>
				<v-flex
					xs12
					py-0
				>
					<v-text-field
						v-model="name"
						:rules="[...validate.require, validate.max(name, 35),
							validateCheckDuplicates(name, existingNames)]"
						name="Name"
						label="Name *"
						autofocus
					/>
				</v-flex>
				<v-flex
					xs12
					class="text-xs-left"
					pt-0
				>
					<OutputSettings
						ref="settings"
						:output-settings="editOutput"
						:disabled="!valid"
						@output-settings="updateOutput"
					>
						<template slot="additional-actions">
							<v-btn
								flat
								color="error"
								@click="$emit('close')"
							>
								close
							</v-btn>
						</template>
					</OutputSettings>
				</v-flex>
			</v-layout>
		</v-form>
	</v-container>
</template>

<script>
import OutputSettings from '@/components/Report/OutputSettings';
import Validation from '@/mixins/Validation';

export default {
	components: {
		OutputSettings,
	},
	mixins: [Validation],
	props: {
		editOutput: { type: Object, default: null },
		existingNames: { type: Array, default: () => [] },
	},
	data() {
		return {
			valid: true,
			name: '',
		};
	},
	created() {
		if (this.editOutput) {
			this.name = this.editOutput.name;
		}
	},
	methods: {
		validateOutput() {
			this.$refs.settings.validate();
		},
		updateOutput(output) {
			output.name = this.name;
			output.save().then(() => {
				this.$notify('success', `Output ${this.name} has been updated.`);
			}).catch(() => {
				this.$notify('error', `Failed to update ${this.name}.`);
			}).finally(() => {
				this.$emit('close');
			});
		},
	},
};
</script>

<style>

</style>
